import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { getCandidate, getAllCandidates } from './data';

const styles = {
  page: { maxWidth: 860, margin: '0 auto', padding: '0 1.5rem 3rem', fontFamily: 'Georgia, serif' },
  topbar: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '1rem 0', borderBottom: '0.5px solid rgba(0,0,0,0.12)', marginBottom: '1.5rem', flexWrap: 'wrap', gap: '0.75rem' },
  logo: { fontSize: 22, fontWeight: 700, color: '#1a1a1a', letterSpacing: '-0.3px', fontFamily: 'Georgia, serif' },
  logoSub: { fontSize: 11, color: '#888', letterSpacing: '0.06em', textTransform: 'uppercase', fontFamily: 'monospace', marginTop: 2 },
  nav: { display: 'flex', gap: '1.25rem', flexWrap: 'wrap' },
  navLink: { fontSize: 13, color: '#666', textDecoration: 'none', cursor: 'pointer', background: 'none', border: 'none', fontFamily: 'Georgia, serif' },
  breadcrumb: { fontSize: 12, color: '#999', fontFamily: 'monospace', marginBottom: '1.25rem', cursor: 'pointer' },
  heroCard: { border: '0.5px solid rgba(0,0,0,0.1)', borderRadius: 12, background: '#fff', padding: '1.5rem', marginBottom: '1.25rem' },
  heroTop: { display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: '1rem', marginBottom: '1.25rem', flexWrap: 'wrap' },
  avatar: { width: 60, height: 60, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 20, fontWeight: 700, flexShrink: 0, fontFamily: 'Georgia, serif' },
  candidateName: { fontSize: 22, fontWeight: 700, color: '#1a1a1a', marginBottom: 4, fontFamily: 'Georgia, serif' },
  candidateDesc: { fontSize: 13, color: '#666', lineHeight: 1.6 },
  tagRow: { display: 'flex', gap: 6, flexWrap: 'wrap', marginTop: 8 },
  tag: { fontSize: 11, padding: '2px 9px', borderRadius: 99 },
  scoreBig: { fontSize: 48, fontWeight: 700, lineHeight: 1, fontFamily: 'Georgia, serif' },
  scoreDenom: { fontSize: 12, color: '#999', fontFamily: 'monospace', marginTop: 2, textAlign: 'right' },
  scoreRank: { fontSize: 12, color: '#666', marginTop: 4, textAlign: 'right' },
  meterTrack: { background: '#F1EFE8', borderRadius: 4, height: 10, width: '100%', overflow: 'hidden', marginBottom: '0.5rem' },
  meterFill: { height: '100%', borderRadius: 4 },
  trendRow: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '0.5rem' },
  statsGrid: { display: 'grid', gridTemplateColumns: 'repeat(4, minmax(0,1fr))', gap: '0.6rem', marginBottom: '1.25rem' },
  statCard: { background: '#f9f9f7', borderRadius: 8, padding: '0.65rem 0.8rem' },
  statLabel: { fontSize: 10, color: '#888', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 3 },
  statVal: { fontSize: 18, fontWeight: 700, color: '#1a1a1a', fontFamily: 'Georgia, serif' },
  statSub: { fontSize: 10, color: '#aaa', marginTop: 1 },
  sectionLabel: { fontSize: 11, color: '#999', textTransform: 'uppercase', letterSpacing: '0.07em', fontFamily: 'monospace', marginBottom: '0.75rem' },
  catBlock: { border: '0.5px solid rgba(0,0,0,0.1)', borderRadius: 12, background: '#fff', marginBottom: '0.9rem', overflow: 'hidden' },
  catHeader: { padding: '0.9rem 1.25rem', borderBottom: '0.5px solid rgba(0,0,0,0.08)', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '1rem' },
  catTitle: { fontSize: 15, fontWeight: 700, color: '#1a1a1a', fontFamily: 'Georgia, serif' },
  catRef: { fontSize: 11, color: '#999', fontFamily: 'monospace', marginTop: 2 },
  catBarMini: { width: 80, height: 6, borderRadius: 3, background: '#F1EFE8', overflow: 'hidden' },
  catBarFill: { height: '100%', borderRadius: 3 },
  catBody: { padding: '1rem 1.25rem', display: 'flex', flexDirection: 'column', gap: '0.9rem' },
  criterion: { display: 'flex', flexDirection: 'column', gap: 5 },
  critTop: { display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: '0.75rem' },
  critText: { fontSize: 14, color: '#1a1a1a', lineHeight: 1.55, flex: 1 },
  critScore: { fontSize: 13, fontFamily: 'monospace', color: '#666', flexShrink: 0, paddingTop: 1 },
  evidence: { background: '#f9f9f7', borderRadius: 8, padding: '0.65rem 0.9rem', fontSize: 13, color: '#555', lineHeight: 1.6 },
  verseWrap: { display: 'flex', alignItems: 'flex-start', gap: 8, marginTop: 6 },
  verseBar: { width: 2, background: '#F09595', borderRadius: 2, flexShrink: 0, alignSelf: 'stretch' },
  verseText: { fontSize: 12, color: '#791F1F', fontFamily: 'Georgia, serif', lineHeight: 1.5, flex: 1, fontStyle: 'italic' },
  verseRef: { fontSize: 11, color: '#A32D2D', fontFamily: 'monospace', marginTop: 2 },
  divider: { border: 'none', borderTop: '0.5px solid rgba(0,0,0,0.06)', margin: '0.25rem 0' },
  historyCard: { border: '0.5px solid rgba(0,0,0,0.1)', borderRadius: 12, background: '#fff', padding: '1.25rem', marginBottom: '1.25rem' },
  histRow: { display: 'flex', gap: 10, alignItems: 'flex-start', paddingBottom: '0.6rem', borderBottom: '0.5px solid rgba(0,0,0,0.06)', marginBottom: '0.6rem' },
  histDate: { fontSize: 11, color: '#999', fontFamily: 'monospace', minWidth: 68, paddingTop: 2 },
  histText: { fontSize: 13, color: '#1a1a1a', lineHeight: 1.5, flex: 1 },
  badgeRed: { fontSize: 10, padding: '2px 7px', borderRadius: 99, background: '#FCEBEB', color: '#A32D2D', flexShrink: 0, marginTop: 2 },
  badgeAmber: { fontSize: 10, padding: '2px 7px', borderRadius: 99, background: '#FAEEDA', color: '#854F0B', flexShrink: 0, marginTop: 2 },
  badgeGray: { fontSize: 10, padding: '2px 7px', borderRadius: 99, background: '#F1EFE8', color: '#5F5E5A', flexShrink: 0, marginTop: 2 },
  otherGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '0.75rem', marginBottom: '1.5rem' },
  otherCard: { border: '0.5px solid rgba(0,0,0,0.1)', borderRadius: 10, background: '#fff', padding: '0.9rem', cursor: 'pointer' },
  disclaimer: { fontSize: 11, color: '#999', lineHeight: 1.65, borderTop: '0.5px solid rgba(0,0,0,0.08)', paddingTop: '1rem', fontStyle: 'italic' },
  notFound: { textAlign: 'center', padding: '4rem 2rem', color: '#666', fontFamily: 'Georgia, serif' },
  catScorePill: { fontSize: 12, padding: '3px 10px', borderRadius: 99 },
};

export default function CandidateProfile() {
  const { id } = useParams();
  const navigate = useNavigate();
  const candidate = getCandidate(id);
  const allCandidates = getAllCandidates();

  if (!candidate) {
    return (
      <div style={{ background: '#fafaf8', minHeight: '100vh' }}>
        <div style={styles.page}>
          <div style={styles.notFound}>
            <h2>Candidate not found</h2>
            <p>Perhaps they have already been cast into the lake of fire.</p>
            <button style={{ ...styles.navLink, marginTop: '1rem', fontSize: 14 }} onClick={() => navigate('/')}>← Return to rankings</button>
          </div>
        </div>
      </div>
    );
  }

  const rank = [...allCandidates].sort((a, b) => b.score - a.score).findIndex(c => c.id === id) + 1;
  const others = allCandidates.filter(c => c.id !== id).sort((a, b) => b.score - a.score).slice(0, 4);

  const getBadgeStyle = (type) => {
    if (type === 'danger') return styles.badgeRed;
    if (type === 'warning') return styles.badgeAmber;
    return styles.badgeGray;
  };

  return (
    <div style={{ background: '#fafaf8', minHeight: '100vh' }}>
      <div style={styles.page}>

        <div style={styles.topbar}>
          <div>
            <div style={styles.logo}>The Antichrist-o-meter</div>
            <div style={styles.logoSub}>Daily prophetic behavioural analysis · est. 2026</div>
          </div>
          <nav style={styles.nav}>
            <button style={styles.navLink} onClick={() => navigate('/')}>Rankings</button>
            <button style={styles.navLink} onClick={() => navigate('/methodology')}>Methodology</button>
            <button style={styles.navLink} onClick={() => navigate('/methodology')}>Scripture index</button>
          </nav>
        </div>

        <div style={styles.breadcrumb} onClick={() => navigate('/')}>
          ← Rankings › {candidate.name}
        </div>

        <div style={styles.heroCard}>
          <div style={styles.heroTop}>
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: 14 }}>
              <div style={{ ...styles.avatar, background: candidate.color + '22', color: candidate.color, border: `0.5px solid ${candidate.color}66` }}>
                {candidate.short}
              </div>
              <div>
                <div style={styles.candidateName}>{candidate.name}</div>
                <div style={styles.candidateDesc}>{candidate.description}</div>
                <div style={styles.tagRow}>
                  <span style={{ ...styles.tag, background: '#FCEBEB', color: '#A32D2D' }}>{candidate.status}</span>
                  <span style={{ ...styles.tag, background: '#FAEEDA', color: '#854F0B' }}>Ranked #{rank} of {allCandidates.length}</span>
                  {candidate.tier === 3 && <span style={{ ...styles.tag, background: '#F1EFE8', color: '#5F5E5A' }}>Historical benchmark</span>}
                </div>
              </div>
            </div>
            <div style={{ textAlign: 'right', flexShrink: 0 }}>
              <div style={{ ...styles.scoreBig, color: candidate.color }}>{candidate.score}%</div>
              <div style={styles.scoreDenom}>of 666 possible</div>
              <div style={styles.scoreRank}>Rank #{rank} · all candidates</div>
            </div>
          </div>

          <div style={styles.meterTrack}>
            <div style={{ ...styles.meterFill, width: `${candidate.score}%`, background: candidate.color }}></div>
          </div>

          <div style={styles.trendRow}>
            <span style={{ fontSize: 12, color: candidate.weeklyDelta > 0 ? '#A32D2D' : '#888' }}>
              {candidate.weeklyDelta > 0 ? `↑ +${candidate.weeklyDelta} pts this week` : candidate.weeklyDelta < 0 ? `↓ ${candidate.weeklyDelta} pts this week` : '— stable this week'}
            </span>
            <span style={{ fontSize: 11, color: '#999', fontFamily: 'monospace' }}>Updated: {new Date().toLocaleDateString('en-GB')} 00:01 UTC</span>
          </div>
        </div>

        {candidate.daysTracked && (
          <div style={styles.statsGrid}>
            <div style={styles.statCard}><div style={styles.statLabel}>Days tracked</div><div style={styles.statVal}>{candidate.daysTracked}</div><div style={styles.statSub}>since Jan 2026</div></div>
            <div style={styles.statCard}><div style={styles.statLabel}>Peak score</div><div style={styles.statVal}>{candidate.peakScore}%</div><div style={styles.statSub}>{candidate.peakDate}</div></div>
            <div style={styles.statCard}><div style={styles.statLabel}>Scored events</div><div style={styles.statVal}>{candidate.scoredEvents}</div><div style={styles.statSub}>across 7 categories</div></div>
            <div style={styles.statCard}><div style={styles.statLabel}>Weekly change</div><div style={{ ...styles.statVal, color: candidate.weeklyDelta > 0 ? '#A32D2D' : '#5F5E5A' }}>{candidate.weeklyDelta > 0 ? '+' : ''}{candidate.weeklyDelta}</div><div style={styles.statSub}>pts this week</div></div>
          </div>
        )}

        <div style={styles.sectionLabel}>Category scores</div>

        <div style={styles.catBlock}>
          <div style={{ padding: '0.9rem 1.25rem', display: 'flex', flexDirection: 'column', gap: 8 }}>
            {candidate.categories.map((cat, i) => (
              <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <span style={{ fontSize: 12, color: '#666', width: 220, flexShrink: 0 }}>{cat.name}</span>
                <div style={{ flex: 1, background: '#F1EFE8', borderRadius: 3, height: 6, overflow: 'hidden' }}>
                  <div style={{ height: '100%', borderRadius: 3, width: `${cat.pct}%`, background: cat.pct >= 80 ? '#E24B4A' : cat.pct >= 60 ? '#D85A30' : '#BA7517' }}></div>
                </div>
                <span style={{ fontSize: 11, color: '#999', fontFamily: 'monospace', width: 50, textAlign: 'right', flexShrink: 0 }}>{cat.score}/{cat.max}</span>
              </div>
            ))}
          </div>
        </div>

        {candidate.criteria && candidate.criteria.length > 0 && (
          <>
            <div style={styles.sectionLabel}>Detailed scoring · with evidence & citations</div>
            {candidate.criteria.map((cat, ci) => (
              <div key={ci} style={styles.catBlock}>
                <div style={styles.catHeader}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                    <span style={{ fontSize: 11, fontFamily: 'monospace', color: '#999', width: 20 }}>{cat.category}</span>
                    <div>
                      <div style={styles.catTitle}>{cat.title}</div>
                      <div style={styles.catRef}>{cat.ref}</div>
                    </div>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexShrink: 0 }}>
                    <div style={styles.catBarMini}>
                      <div style={{ ...styles.catBarFill, width: `${cat.pct}%`, background: cat.color }}></div>
                    </div>
                    <span style={{ ...styles.catScorePill, background: cat.pillBg, color: cat.pillColor }}>{cat.score} / {cat.max}</span>
                  </div>
                </div>
                <div style={styles.catBody}>
                  {cat.items.map((item, ii) => (
                    <div key={ii}>
                      {ii > 0 && <hr style={styles.divider} />}
                      <div style={styles.criterion}>
                        <div style={styles.critTop}>
                          <span style={styles.critText}>{item.text}</span>
                          <span style={styles.critScore}>{item.score}</span>
                        </div>
                        <div style={styles.evidence}>
                          <strong>Evidence:</strong> {item.evidence}
                          <div style={styles.verseWrap}>
                            <div style={styles.verseBar}></div>
                            <div>
                              <div style={styles.verseText}>{item.verse}</div>
                              <div style={styles.verseRef}>{item.verseRef}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </>
        )}

        {candidate.recentEvents && candidate.recentEvents.length > 0 && (
          <>
            <div style={styles.sectionLabel}>Recent scoring events</div>
            <div style={styles.historyCard}>
              {candidate.recentEvents.map((ev, i) => (
                <div key={i} style={{ ...styles.histRow, ...(i === candidate.recentEvents.length - 1 ? { borderBottom: 'none', marginBottom: 0, paddingBottom: 0 } : {}) }}>
                  <span style={styles.histDate}>{ev.date}</span>
                  <span style={styles.histText}>{ev.text}</span>
                  <span style={getBadgeStyle(ev.type)}>{ev.category} {ev.delta}</span>
                </div>
              ))}
            </div>
          </>
        )}

        <div style={styles.sectionLabel}>Other candidates</div>
        <div style={styles.otherGrid}>
          {others.map(c => (
            <div key={c.id} style={styles.otherCard} onClick={() => navigate(`/candidate/${c.id}`)}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <div style={{ width: 28, height: 28, borderRadius: '50%', background: c.color + '22', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 10, fontWeight: 700, color: c.color, border: `0.5px solid ${c.color}44`, fontFamily: 'Georgia, serif' }}>{c.short}</div>
                  <span style={{ fontSize: 13, fontWeight: 700, color: '#1a1a1a', fontFamily: 'Georgia, serif' }}>{c.name.split(' ')[0]}</span>
                </div>
                <span style={{ fontSize: 16, fontWeight: 700, color: c.color, fontFamily: 'Georgia, serif' }}>{c.score}%</span>
              </div>
              <div style={{ background: '#F1EFE8', borderRadius: 3, height: 4, overflow: 'hidden' }}>
                <div style={{ height: '100%', borderRadius: 3, width: `${c.score}%`, background: c.color }}></div>
              </div>
            </div>
          ))}
        </div>

        <div style={styles.disclaimer}>
          All evidence cited above is drawn from documented public statements, verified news reports, and official records. Scores represent satirical behavioural analysis against prophetic criteria and do not constitute claims of literal supernatural identity, theological assertion, or legal defamation of any individual. The editors acknowledge that selling a branded Bible for $59.99 may not, strictly speaking, constitute blasphemy under applicable law. We note this with some disappointment.
        </div>

      </div>
    </div>
  );
}
